
<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="medium"
             color="#000000"
             type="ball-spin-clockwise">
</ngx-spinner>
<div class="modal-content modal-content-width border-all-10px-modal">
  <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">
    <div class="card-header wh-header border-bottom padding-bottom-5px padding-left-15px padding-right-15px">
      <div class="row">
        <div class="col-md-3">
          Cycle Search
        </div>
        <div class="col-md-8 float-right padding-right-0px padding-l-0px display-inherit">
          <form novalidate="" #f="ngForm" class="display-inherit margin-left-auto">
            <div class="clear-form">
              <input type="text" class="form-control" placeholder="Search" [(ngModel)]="searchValue" name="searchBar" [value]='searchValue' maxlength="15">
              <a (click)="ClearInput()" class="nav-link-hand" title="Clear" *ngIf="searchValue!=null"><span class="clear-icon"><i class="fa fa-times"></i></span></a>
            </div>
            <button (click)="criteriaChange(searchValue)" class="btn font-size-13px actions-btn-prime margin-right-auto margin-left-5px">Go</button>
          </form>
        </div>
        <div class="col-md-1 padding-left-0px">
          <button *ngIf="Frombills" type="button" class="close" data-dismiss="modal"
                  (click)="activeModal.close('Cross click')"
                  aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <button *ngIf="NotFrombills" type="button" class="close" data-dismiss="modal"
                  (click)="activeModal.dismiss('Cross click')"
                  aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>
    </div>

    <div class="modal-body padding-top-0px counselling-modal">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body padding-top-0px padding-left-0px padding-right-0px padding-bottom-0px">
              <div class="table-component">
                <div class="table-responsive overflow-x">
                  <table class="table table-striped width-100pe margin-left-zero"
                         cols="auto,2*,*,*,*,*,*,*">
                    <thead class="">
                      <tr>
                        <th></th>
                        <th class="">
                          PID
                        </th>
                        <!--<th class="">
                          Cycle#
                        </th>-->
                        <th class="padding-left-4">
                          Name
                        </th>
                        <th class="">
                          Contact
                        </th>
                        <th class="padding-left-9px">
                          Sex &amp; Age
                        </th>
                        <th></th>
                        <th>Protocol</th>
                        <!--<th>Prtcl Start Date</th>-->
                        <th class="padding-left-10px">Cycle Type</th>
                        <!--<th>Duration</th>-->
                        <th>Comp.Status</th>
                      </tr>
                    </thead>

                    <tbody class="table-body">
                      <tr *ngFor="let l of CurrentTreatmentCyclesController">
                        <td class="padding-all-0px">
                          <button 
                                  type="button" class="btn font-size-13px actions-btn-prime" (click)="activeModal.close(l)">
                            Select
                          </button>                          
                        </td>
                        <td class="td-padding-tb padding-top-0px padding-bottom-0px padding-right-0px">
                          {{l.PatientRegNo}}
                        </td>
                        <!--<td class=" padding-top-0px padding-bottom-0px text-align-right ">
                          {{l.CycleNo}}
                        </td>-->
                        <td class="td-padding padding-top-0px padding-bottom-0px ">
                          {{l.DisplayName}}
                        </td>
                        <td class=" td-padding-tb padding-top-0px padding-bottom-0px">{{l.Telephone1}}</td>
                        <td class=" td-padding-tb padding-top-0px padding-bottom-0px">{{l.Gender}} &amp; {{l.Age}}</td>
                        <td class=" td-padding-tb padding-top-0px padding-bottom-0px">{{l.TCModelName}}</td>
                        <td class="td-padding-tb padding-top-0px padding-bottom-0px">{{l.ProtocolName}}</td>
                        <!--<td class="td-padding-tb padding-top-0px padding-bottom-0px">{{l.ProtocolStartDate| date:'MMM-dd-yyyy'}}</td>-->
                        <td class="td-padding-tb padding-top-0px padding-bottom-0px ">{{l.CycleType}}</td>
                        <!--<td class=" td-padding-tb padding-top-0px padding-bottom-0px">{{l.Duration}} days</td>-->
                        <td class="padding-top-0px padding-bottom-0px">{{l.CompletedStatus}}</td>
                      </tr>
                    </tbody>

                  </table>
                </div>
              </div>              
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
